import HeaderController from './header.controller';
import { HeaderProps } from './header.model';

const Header = (props: HeaderProps): JSX.Element => {
  return <HeaderController {...props} />;
};

export default Header;
